import { apiUrls } from 'consts'
import { useEffect } from 'react'
import loadRecord from './../utils/loadRecord'
import getAll from 'utils/getAll'

interface useInitProps {
  getValues: Function
  setParentFilters: Function
  setConnections: Function
  id: string | undefined
  reset: Function
  setDataLoaded: Function
  setFilterLoaded: Function
  currentCustomer: {} | null
}

const useInit = (props: useInitProps) => {
  useEffect(() => {


    let parentFilters: Array<any> = []
    const parentFiltersPromise = getAll(apiUrls.actionGetParentFilters + '?id=' + (props.id === undefined ? '' : props.id)).then((data) => {
      parentFilters = data
    })

    let connections: Array<any> = []
    const connectionsPromise = getAll(apiUrls.connections).then((data) => {
      connections = data
    })

    // fetch the device if edit
    if (props.id !== undefined) {
      loadRecord(apiUrls.filters, props.id).then((data) => {
        props.reset({
          ...data,
          is_multi: data.is_multi === 1,
          sync: data.sync === 1,
          display_select_all: data.display_select_all === 1,
          select_all_is_default: data.select_all_is_default === 1,
        })

        Promise.all([connectionsPromise, parentFiltersPromise]).then(() => {
          props.setConnections(connections)
          props.setParentFilters(parentFilters)
          props.setDataLoaded(true)
          props.setFilterLoaded(true)
        })
      })
    } else {
      Promise.all([connectionsPromise, parentFiltersPromise]).then(() => {
          props.setConnections(connections)
          props.setParentFilters(parentFilters)
          props.setDataLoaded(true)
          props.setFilterLoaded(true)
          props.reset({
          connection: null,
          syncType: null,
        })
      })  
    }


  }, [props.currentCustomer])
}

export default useInit
